// extracted by mini-css-extract-plugin
export default {"scroll":"tasks_scroll__zyUhN","notFound":"tasks_notFound__ui9fX"};